export function onSliderChange(setInputValue: (value: number) => void) {
  return (value: number) => setInputValue(value);
}

export function getSliderStepValue(balance: number, sliderStep: number): number {
  return balance === 0 ? 0 : sliderStep;
}

export function getMinimumBalanceValue(balance: number, minTxnValue: number): number {
  if (balance < minTxnValue) {
    return balance;
  }
  return balance === 0 ? 0 : minTxnValue;
}

export function isValidNumberWithDot(input: string): boolean {
  const regex = /^[0-9]*\.?[0-9]*$/;
  return regex.test(input);
}

export const isWithdrawButtonDisabled = (
  amountValue: number | string,
  minValue: number,
  maxValue: number,
  isEnabled: boolean,
): boolean => {
  const parsedInt = typeof amountValue === 'number' ? amountValue : parseInt(amountValue, 10);
  return parsedInt < minValue || parsedInt > maxValue || !isEnabled;
};
